export default function PartnerAgreement({}) {
  return (
    <div className="grid gap-4 text-sm text-stone-400">
      <p className="font-semibold text-stone-200">
        POSH FLEET ACQUISITION PARTNER AGREEMENT
      </p>
      <p>
        This Consulting Agreement (the "Agreement") is entered by and between
        POSHIT INC., a Delaware corporation, with its principal place of
        business located at 12180 Garland Rd Dallas, TX 75218 ("COMPANY") and
        (Your Company / Your Name)(FLEET ACQUISITION PARTNER "FAP"). COMPANY and
        FAP may be referred to herein individually as a "Party" and collectively
        as the "PARTIES."
      </p>
      <p className="font-semibold text-stone-200">RECITALS</p>
      <p>
        WHEREAS, COMPANY is a decentralized fleet management company that
        provides an online car subscription platform to subscribers.
        COMPANY&apos;S service is accessible online including at poshcars.io and
        as an application for mobile devices. The COMPANY websites, blog, mobile
        applications, and associated services are collectively referred to as
        “the Services”. By agreeing to list FAP cars with COMPANY, including by
        communicating with COMPANY, FAP agrees to comply with, and be legally
        bound by, the provisions of these Terms of Service (these “Terms”).
        These Terms govern FAP rights and responsibility and constitute a
        binding legal agreement between FAP and COMPANY.
      </p>
      <p>
        WHEREAS, COMPANY desires to engage FAP to become a Fleet Acquisition
        FAP; and WHEREAS, FAP fulfills all criteria to be a Fleet Acquisition
        FAP; and WHEREAS, the PARTIES desire to set forth the terms and
        conditions of their agreement;
      </p>
      <p>
        NOW, THEREFORE, COMPANY looks for high quality FAPs to entrust their
        vehicles to its custodianship or private lease. FAPs can list vehicles
        they already own or work with COMPANY to determine which vehicles are in
        demand, purchase, and list the vehicles on our platforms. COMPANY
        reserves the sole right to set up qualifications for the vehicles and
        determine if FAPs&apos; vehicles meet the requirements to be listed on
        its platforms. The PARTIES in consideration of the mutual covenants and
        promises contained herein, agree as follows:
      </p>

      <p className="font-semibold text-stone-200">I. ELIGIBILITY</p>
      <p>
        FAP must meet the following requirements in order to participate in our
        FAP Program:
      </p>
      <div className="grid gap-2">
        <p>A. Must be 23+ years or older with a clean driving record</p>
        <p>B. Must be US citizen or permanent resident</p>
        <p>C. Must be employed</p>
        <p>
          D. Must have 720+ credit score and must unfreeze credit profiles at 3
          bureaus 2 weeks prior to onboarding
        </p>
        <p>
          E. Must have an active business with a tax liability or willing to set
          up a new business with EIN with incoming revenue (ask CPA for best use
          case for existing and future)
        </p>
        <p>F. Must apply for vehicle financing</p>
        <p>G. No delinquencies or negative public records</p>
        <p>H. No criminal history</p>
        <p>
          I. Must consent to all COMPANY&apos; terms including Material
          Participation Compliance Rules
        </p>
        <p>
          J. Must create business profile at partner.poshcars.io and customer
          profile at www.poshcars.io to access partner portal
        </p>
        <p>
          K. Must fill out the credit profile on the FAP portal, upload all
          required documents and sign the Online FAP agreement
        </p>
        <p>
          L. Must actively make direct on-time monthly loan payments to
          financers for current vehicles on the agreed upon schedule and keep
          all loans in good standing. FAP is required to make on-time loan
          payments and COMPANY will be responsible for sending same day loan
          payment reimbursements on time to FAP
        </p>
        <p>
          M. Must allow COMPANY to fully manage all vehicle assets as POA (Power
          of Attorney) without any restrictions for:
        </p>
        <p className="ml-4">a. Preferred vehicle and dealership selections</p>
        <p className="ml-4">b. Car registration</p>
        <p className="ml-4">c. Insurance claims</p>
        <p className="ml-4">d. Car Loan payments</p>
        <p>
          N. Must provide COMPANY a copy the required documentation upon
          financing vehicles:
        </p>
        <p className="ml-4">a. Purchase Agreement</p>
        <p className="ml-4">b. Tax, Title, &amp; License records</p>
        <p className="ml-4">c. Warranty Contracts</p>
        <p className="ml-4">d. Inspection Report</p>
        <p>
          O. Must finance a minimum of 5 vehicles up to a maximum of 15 vehicles
        </p>
        <p>
          P. Must agree to a minimum financing term of 60-months but not to
          exceed 84 months
        </p>
      </div>

      <p className="font-semibold text-stone-200">II. VERIFICATION</p>
      <p>
        When FAP entrusts its vehicles to COMPANY, FAP must provide accurate,
        current, and complete information including first and last name, email
        address, address, phone number, and a payment method for registration
        renewal and property taxes. IRS refunds registration and property taxes
        to FAP on tax return. FAP will be required to create an FAP account on
        the COMPANY portal to track all its vehicles, active (listed and ready
        to use for subscribers on the portal) /inactive(under damaged claims or
        general service) status, performance and earnings. Where permitted,
        COMPANY has the right, but not the obligation, to undertake screenings,
        checks, and engage in processes designed to:
      </p>
      <div className="grid gap-2">
        <p>
          A. Verify FAP identity and background, including driving history and
          driver&apos;s license validity and verify vehicle details.
        </p>
        <p>
          B. COMPANY does not endorse any user, or a user&apos;s background, or
          commit to undertake any specific screening process.
        </p>
        <p>
          C. COMPANY may exercise in its sole discretion ongoing use of
          third-party services to verify the information FAP provides to COMPANY
          and to obtain additional related information and corrections where
          applicable, and FAP hereby authorizes COMPANY to request, receive,
          use, and store such information.
        </p>
      </div>

      <p className="font-semibold text-stone-200">
        III. VEHICLE ACQUISITIONS PROCESS
      </p>
      <p>
        FAP consents to allowing COMPANY to acquire vehicles through its
        pre-selected partners and financial institutions, and car dealership
        contacts to check FAP credit scores and ability to take out loans under
        FAPs name (if applicable). If FAP is not approved for the loans, COMPANY
        reserves the right to deny FAP participation unless other arrangements
        can be made. Once approved, FAP agrees to make direct on-time monthly
        vehicle payments to the financer on the agreed upon schedule and keep
        the loan in good standing. If FAP fails to keep up with any vehicle
        payments, COMPANY and its service providers will employ all legal
        methods available to collect amounts due, including the engagement of
        collection agencies or legal counsel. FAP agrees to allow COMPANY&apos;
        access to the car payment profile. When FAP provides a payment method,
        FAP authorizes COMPANY, or third-party service providers acting on
        behalf of COMPANY, to store FAP payment credentials for future use.
      </p>

      <p className="font-semibold text-stone-200">IV. EARNINGS</p>
      <div className="grid gap-2">
        <p>
          A. COMPANY guarantees a minimum earnings equivalent to the monthly
          payment of the vehicle.
        </p>
        <p>
          B. The first payment shall occur 30 days after the vehicle is live on
          the COMPANY platform.
        </p>
        <p>
          C. In case of vehicle being damaged, under repairs or maintenance,
          COMPANY shall continue covering the monthly payments
        </p>
      </div>

      <p className="font-semibold text-stone-200">
        V. BENEFITS TO FLEET ACQUISITION PARTNER (FAP)
      </p>
      <div className="grid gap-2">
        <p>
          A. FAP may be eligible to qualify for Schedule C Section 179 and/or
          bonus depreciation deductions minimize business tax liabilities.
          Disclaimer: Please be advised that there may be different limits for
          light and heavy vehicles that are subject to eligibility rules.
          COMPANY recommends that FAP consults a licensed Certified Public
          Accountant (CPA) or experienced business tax professional to ensure
          eligible deductions are applied correctly to maximize this FAP
          benefit.
        </p>
        <p>
          B. Receive a complimentary lifetime POSH subscription with $0 setup
          fees. COMPANY offers three (3) different subscription plans as
          described here: https://poshcars.io/pricing
        </p>
        <p className="ml-4">
          a. FAP may drive one (1) car of choice and receive a reward credit
          from the COMPANY toward chosen subscription level based upon the
          number of cars to be financed as defined below. FAP is responsible for
          paying the monthly differential cost between the credit and selected
          subscription level. ( If fleet partner does not utilize the vehicle
          credits , partner can redeem these for cash at 0.8 ratio at the end of
          each billing cycle. Partner credits take affect 60 days from the day
          of vehicle on-boarding)
        </p>
        <p className="ml-4">
          b. $800 FAP reward credit for 5 active vehicles with POSH
        </p>
        <p className="ml-4">
          c. $1300 FAP reward credit for 10 active vehicles with POSH
        </p>
        <p className="ml-4">
          d. $1500 FAP reward credit for 15 active vehicles with POSH
        </p>
        <p>C. Freedom to choose an option below</p>
        <p className="ml-4">
          a. Trade the vehicles in for newer vehicles to the COMPANY after the
          first 12 months or after the full financing term
        </p>
        <p className="ml-4">
          b. Keep the vehicles free and clear once the vehicle loans are paid
          off
        </p>
        <p className="ml-4">
          c. For FAPs with their own fleet of paid off cars, COMPANY will agree
          to buy eligible vehicles, resulting in guaranteed monthly payments
        </p>
      </div>

      <p className="font-semibold text-stone-200">VI. FAP COMMITMENTS</p>
      <div className="grid gap-2">
        <p>
          A. Allow COMPANY full control to list FAP cars on COMPANY platforms
        </p>
        <p>
          B. Allow COMPANY to handle all operations of all FAP cars at its sole
          discretion, including pricing, millage, reviews, feedback, photos,
          description of the vehicles, or trips, at COMPANY or other third-party
          platforms.
        </p>
        <p>
          C. Redirect any third-party insurance claims communications for active
          vehicles to the COMPANY Team
        </p>
        <p>
          D. Purchase extended warranty and maintenance plan for all vehicles
          leased to COMPANY
        </p>
      </div>

      <p className="font-semibold text-stone-200">
        VII. CONTENT AND USER CONTENT LICENSE
      </p>
      <div className="grid gap-2">
        <p>
          A. Subject to FAP compliance with the provisions of these Terms,
          COMPANY grants FAP a limited, revocable, non-exclusive,
          non-transferable license, to access and view any COMPANY and/or user
          content to which FAP is permitted access, solely for FAP personal and
          non-commercial purposes. FAP has no right to sublicense the license
          rights granted in this section. No licenses or rights are granted to
          FAP by implication or otherwise under any intellectual property rights
          owned or controlled by COMPANY or its licensors, except for the
          licenses and rights expressly granted in these Terms.
        </p>
        <p>
          B. COMPANY may, in its sole discretion, permit FAP to post, upload,
          publish, submit or transmit content through the Services such as
          photographs of FAP and FAP&apos;s vehicle(s), reviews, feedback, and
          descriptions of FAP, FAP vehicle, or trip. By sharing or making
          available any content on or through the Services, or through COMPANY
          promotional campaigns, FAP grants COMPANY a worldwide, irrevocable,
          perpetual (or for the term of the protection), non-exclusive,
          transferable, royalty-free license, with the right to sublicense, to
          use, view, copy, adapt, modify, distribute, transfer, publicly
          display, publicly perform, transmit, stream, broadcast, access, view,
          and otherwise exploit such content on, through, by means of, or to
          promote or market the Services.
        </p>
        <p>
          Except as described above, COMPANY does not claim any ownership rights
          in any such content and nothing in these Terms will be deemed to
          restrict any rights that FAP may have to use and exploit any such
          content.
        </p>
      </div>

      <p className="font-semibold text-stone-200">
        VIII. PROHIBITED ACTIVITIES
      </p>
      <p>
        To maintain eligibility, FAP agrees to not advocate, encourage, request,
        or assist any third party to violate any law, including:
      </p>
      <div className="grid gap-2">
        <p>
          A. Breach, violate, and/or circumvent any local, state,
          provincial/territorial, regional, or national law or other law or
          regulation, or any order of a court, including, without limitation,
          airport regulations and tax regulations, licensing or registration
          requirements, or third-party rights
        </p>
        <p>
          B. Post false, inaccurate, misleading, defamatory, or libelous content
        </p>
        <p>
          C. Infringe, reproduce, perform, display, distribute, reverse
          engineer, or prepare derivative works from content that belongs to or
          is licensed to COMPANY, or that comes from the Services and belongs to
          or other intellectual property privacy, publicity, moral, or
          contractual rights, except with prior express written permission of
          COMPANY
        </p>
        <p>
          D. Dilute, tarnish, or otherwise harm the COMPANY brand in any way,
          including:
        </p>
        <p className="ml-4">
          i. Through unauthorized use of the Services and/or user content
        </p>
        <p className="ml-4">
          ii. Register and/or use "COMPANY" name or derivative terms in domain
          names, trade names, trademarks, or otherwise
        </p>
        <p className="ml-4">
          iii. Register and/or use domain names, trade names, trademarks, social
          media account names, or means of identification that closely imitate
          or are confusingly similar to COMPANY domains, trademarks, taglines,
          promotional campaigns, or COMPANY and/or user content
        </p>
        <p>
          E. Provide or submit any false or misleading information, including:
        </p>
        <p className="ml-4">
          i. False name, date of birth, driver&apos;s license details, payment
          method, insurance, or other personal information
        </p>
        <p className="ml-4">
          ii. In relation to a claim (for example about damage to a vehicle)
        </p>
        <p className="ml-4">
          iii. Impersonating any person or entity, or falsifying or otherwise
          misrepresenting FAP affiliation with any person or entity
        </p>
      </div>

      <p className="font-semibold text-stone-200">IX. OTHER LEGAL MATTERS</p>
      <p>
        Violations. COMPANY has the right, but not the obligation, to
        investigate, pursue, and seek to prosecute, litigate, or refer to law
        enforcement, violations of the Agreement to the fullest extent
        permissible by the law. COMPANY reserves the right, at any time and
        without prior notice, in accordance with applicable law, to remove or
        disable access to any content that COMPANY, at its sole discretion,
        considers to be objectionable for any reason, in violation of these
        Terms, or otherwise harmful to the Services or our community. If FAP is
        abusing COMPANY, its subscribers, or any other person in any way or
        violating the letter or spirit of any of these Terms, COMPANY may, in
        its sole discretion and without limiting other remedies, limit, suspend,
        or terminate FAP access to the services, financial agreements, remove
        hosted content, deny a damage claim, remove or demote FAP listings,
        reduce or eliminate any discounts, and take technical and/or legal steps
        to prevent FAP from using the Services. Additionally, COMPANY reserves
        the right to refuse or terminate access to the Services to FAP for any
        reason at our discretion to the full extent permitted under applicable
        law.
      </p>
      <p>
        Policy enforcement. When an issue arises, COMPANY may consider the
        FAP&apos;s performance history and the specific circumstances in
        applying COMPANY Policies. COMPANY may choose to be more lenient with
        policy enforcement in an effort to do the right thing, subject to
        COMPANY sole and absolute discretion.
      </p>
      <p>
        COMPANY Communications with FAP. FAP agrees that COMPANY may contact FAP
        by electronic means (e.g., electronic mail; notifications via COMPANY
        messaging; app notification) in lieu of any requirement for mailed
        notices. To contact FAP more efficiently, FAP agrees that COMPANY may at
        times also contact FAP using autodialed or prerecorded voicemail
        messages or text messages at FAP phone number(s). COMPANY may place such
        calls or texts primarily to confirm FAP&apos;s signup, provide notices
        regarding FAP/COMPANY agreement or COMPANY activity, investigate or
        prevent fraud, collect a debt owed to COMPANY, or communicate urgent
        messages. COMPANY may share FAP&apos;s phone number(s) with service
        providers with whom COMPANY contracts to assist in pursuing these
        interests. COMPANY will not share FAP phone number(s) with third PARTIES
        for their own purposes without FAP consent. Standard telephone minute
        and text and data charges may apply. Where COMPANY is required to obtain
        FAP consent for such communications, FAP may choose to revoke FAP
        consent.
      </p>
      <p>
        FAP authorizes COMPANY and its service providers, without further notice
        or warning and in COMPANY discretion, to monitor or record telephone
        conversations with FAP or anyone acting on FAP&apos;s behalf with
        COMPANY or its agents for quality control and training purposes. FAP
        acknowledges and understands that FAP communications with COMPANY may be
        overheard, monitored, or recorded without further notice or warning.
      </p>
      <p>
        Non-disparagement. PARTIES agree they will not take any action that will
        harm the reputation of the other Party, or which would reasonably be
        expected to lead to unwanted or unfavorable publicity to either of the
        other Party.
      </p>
      <p>
        Insurance and protection plans. COMPANY is not an insurance company and
        does not insure FAPs or its subscribers. FAPs and subscriber protection
        plans made available through the COMPANY Services are in no way related.
        To be eligible for the benefits of a protection plan, FAPs and
        subscribers must comply with third party insurance company terms.
        Protection plans are available through the Services only in the United
        States.
      </p>

      <p className="font-semibold text-stone-200">X. COMPANY COMMITMENTS</p>
      <p className="font-semibold">A. VEHICLE PAYMENTS</p>
      <p>
        The COMPANY shall be responsible for the timely payment of all fleet
        vehicle expenses incurred while the vehicles are under COMPANY&apos;s
        management and control.
      </p>
      <p>i. Initial Payment</p>
      <p>
        COMPANY agrees to remit the first month&apos;s fleet payment on behalf
        of the Fleet Acquisition Partner (FAP) from its escrow account to ensure
        there are no delays during the onboarding process.
      </p>
      <p>ii. Ongoing Payments</p>
      <p>
        COMPANY shall submit all subsequent monthly payments to FAP no later
        than one (1) business day prior to the fleet payment due date. FAP shall
        be responsible for submitting the monthly payments to the lender. To
        ensure payment compliance, FAP agrees to opt in to receive automated
        monthly reminder alerts via the Posh Partner Portal. In the event
        COMPANY fails to make timely payments, COMPANY shall be liable for any
        resulting late fees, penalties, and legal expenses incurred due to such
        delinquency.
      </p>

      <p className="font-semibold">
        B. TOLLS, PARKING, AND SPEEDING CITATION PAYMENTS
      </p>
      <p>
        FAP acknowledges that fleet vehicles operated by COMPANY subscribers may
        incur tolls, parking fees, or traffic citations, which are the
        responsibility of the subscriber. COMPANY is responsible for collecting
        and settling these charges monthly.
      </p>
      <p>i. Toll Payment Options</p>
      <p>FAP may select one of the following toll billing options:</p>
      <p>
        ● Option 1: Direct Billing via POSH Toll Account FAP agrees to follow
        POSH&apos;s instructions to link each fleet vehicle to COMPANY&apos;s
        toll billing account. All tolls will be billed directly to COMPANY for
        payment.
      </p>
      <p>
        ● Option 2: FAP-Paid Toll Reimbursement FAP may choose to pay all tolls
        incurred by their fleet vehicles and submit monthly invoices through the
        POSH Partner Portal (https://partner.poshcars.io/) for reimbursement by
        COMPANY. If FAP selects this option, they must contact mgmt@poshcars.io
        to receive toll tags for each vehicle. Tolls incurred during personal
        use by FAP will not be reimbursed and remain the responsibility of FAP.
      </p>
      <p>ii. Citations and Out-of-Region Tolls</p>
      <p>
        In cases where COMPANY subscribers incur tolls outside of COMPANY&apos;s
        standard service regions (currently Texas and Boston), or are issued
        parking/speeding citations while driving FAP fleet vehicles, these
        notices may be mailed directly to FAP as the registered vehicle owner.
        FAP shall upload all such notices and related invoices to the POSH
        Partner Portal for reimbursement. COMPANY shall reimburse FAP monthly
        for the full amount of approved citation fees. If any late fees result
        from COMPANY subscriber delay or non-payment, COMPANY will assume
        responsibility for those additional charges.
      </p>

      <p className="font-semibold">C. AUTO LIABILITY INSURANCE</p>
      <p>
        FAP is not required to carry insurance coverage on vehicles leased to
        COMPANY, but is required to carry insurance coverage for vehicles under
        their personal usage.. COMPANY carries comprehensive commercial
        insurance coverage up to $75K in property damage and no medical payments
        under an automobile liability insurance policy. FAPs are required at any
        given moment to carry full insurance coverage to drive COMPANY vehicles.
        This policy covers all the assets under COMPANY&apos;s management
        including subscribers who drive the vehicles and COMPANY employees
        handling the vehicles for COMPANY business purposes.
      </p>

      <p className="font-semibold">D. MAINTENANCE</p>
      <p>
        COMPANY will be responsible for the maintenance and repair of any FAP
        vehicles leased while under COMPANY&apos;s contract. This does not
        contradict with COMPANY&apos;s requirement that all vehicles must have
        prepaid maintenance and extended warranty with the dealership which FAP
        may be financially responsible for at the purchase of the vehicle. While
        in COMPANY possession, COMPANY will be responsible for the safety,
        roadworthiness, or legal status (e.g., whether the vehicle is legally
        registered or the subject of a stolen vehicle report) of FAP vehicles,
        as well as ensuring the vehicles are in safe and operable condition,
        legally registered to be driven on public roads, not subject to a
        missing or stolen vehicle report, have a clean title
        (e.g.non-salvaged/non-branded/non-washed/non-written off), not subject
        to any applicable safety recalls, and otherwise satisfy our eligibility
        requirements.
      </p>

      <p className="font-semibold">E. CONTRACT TERMINATION</p>
      <p>
        FAPs acknowledge that COMPANY has requirements for vehicles that are
        eligible to be listed on our platforms and operations. If at any moment,
        COMPANY deems FAP vehicles are not safe and in operable condition,
        COMPANY reserves the right to de-list FAP vehicles. If the vehicle is
        considered to be no longer appropriate to be listed on our Services,
        COMPANY will give FAP termination notice 90 days in advance and will
        continue to pay FAP the agreed upon monthly payment for the vehicle
        during this period. After 90 days, any contract and COMPANY obligations
        concerning this vehicle will be terminated. If COMPANY is unable to
        fulfill its obligations to FAP after 30 days, the contract is considered
        terminated. FAP can withdraw the vehicle from COMPANY possession and
        request that they no longer be listed with COMPANY services. In the
        event COMPANY chooses to delist any vehicles from FAP, FAP can decide to
        either take custody of the vehicles or allow COMPANY to sell those
        vehicles on their behalf.
      </p>

      <p className="font-semibold">F. COMPANY PHOTOGRAPHY</p>
      <p>
        COMPANY may offer FAPs the option of having photographers take
        photographs of their vehicles and/or FAPs with their vehicles
        (“Images”). FAP agree that COMPANY is the sole and exclusive owner - or
        exclusive licensee, as allowed by applicable law - of all right, title,
        and interest in all copyrights, trademark rights, and any and all other
        intellectual property rights, including right of publicity, worldwide,
        in the Images regardless of whether they are included in the listing,
        and FAP shall take no action to challenge or object to the validity of
        such rights or COMPANY&apos;s ownership or registration thereof. FAP
        acknowledges that COMPANY may use the Images for advertising, marketing,
        commercial, and other business purposes in any media or platform,
        whether in relation to FAP listings or otherwise, without further notice
        or compensation. Further, FAP waive any and all rights to royalties or
        moral rights FAP may have in the images. If FAP uses the COMPANY
        photography program, FAP agrees that FAP will not use the Images in
        connection with sharing FAP vehicles on any platform, website, or
        application other than explicitly allowed by COMPANY. At COMPANY&apos;s
        request, FAP will execute documents and take such further acts as
        COMPANY may reasonably request to assist COMPANY to acquire, perfect,
        and maintain its intellectual property rights and other legal protection
        in the Images.
      </p>

      <p className="font-semibold text-stone-200">XI. VEHICLE AGREEMENT</p>
      <p>
        FAP agrees to sign a vehicle agreement for each individual vehicle for
        it to be considered to be acquired by the COMPANY.
      </p>

      <p className="font-semibold text-stone-200">XII. POWER OF ATTORNEY</p>
      <div className="grid gap-2">
        <p>
          A. FAP hereby agrees to grant and assign Power of Attorney to the
          COMPANY for the limited purpose of managing all matters related to the
          vehicles enrolled under this Agreement. This authorization includes,
          but is not limited to, the following actions:
        </p>
        <p className="ml-4">1. Renewing vehicle registrations and titles;</p>
        <p className="ml-4">
          2. Coordinating and managing all aspects of vehicle maintenance and
          service;
        </p>
        <p className="ml-4">
          3. Addressing and resolving disputes or issues with private parties or
          governmental authorities;
        </p>
        <p className="ml-4">
          4. Representing FAP in any legal or administrative matters directly
          related to the vehicles covered under this Agreement.
        </p>
        <p>
          B. FAP acknowledges and agrees that the COMPANY may act on their
          behalf in the above matters for the duration of this Agreement and
          that such authority is necessary to ensure timely and efficient
          vehicle operations and compliance. This limited Power of Attorney
          shall remain in effect until the termination or expiration of this
          Agreement unless otherwise revoked in writing with reasonable advance
          notice.
        </p>
      </div>

      <p className="font-semibold text-stone-200">XIII. CONFIDENTIALITY</p>
      <div className="grid gap-2">
        <p>
          A. FAP agrees to maintain in strict confidence all information
          provided by COMPANY that is designated as confidential or that
          reasonably should be understood to be confidential, including but not
          limited to business plans, financial data, investor information, and
          proprietary information ("Confidential Information").
        </p>
        <p>
          B. FAP shall not disclose or use any confidential information for any
          purpose other than to perform the Services under this Agreement.
        </p>
        <p>
          C. The obligations under this Section shall survive termination of
          this Agreement.
        </p>
      </div>

      <p className="font-semibold text-stone-200">XIV. INTELLECTUAL PROPERTY</p>
      <p>
        All work products, including but not limited to reports, presentations,
        and campaign materials, created by COMPANY in connection with the
        Services shall be the sole and exclusive property of COMPANY. FAP hereby
        assigns all rights, title, and interest in such work product to COMPANY.
      </p>

      <p className="font-semibold text-stone-200">XV. INDEMNIFICATION</p>
      <p>
        Each Party shall indemnify, defend, and hold harmless the other Party
        from and against any and all claims, liabilities, losses, damages, and
        expenses (including reasonable attorneys' fees) arising out of or
        related to the indemnifying Party's breach of this Agreement or gross
        negligence or willful misconduct.
      </p>

      <p className="font-semibold text-stone-200">
        XVI. GOVERNING LAW AND DISPUTE RESOLUTION
      </p>
      <div className="grid gap-2">
        <p>
          A. Governing Law: This Agreement shall be governed by and construed in
          accordance with the laws of the State of Delaware, without regard to
          its conflict of laws principles.
        </p>
        <p>
          B. Dispute Resolution: Any dispute arising under or related to this
          Agreement shall be resolved through binding arbitration in Delaware,
          in accordance with the rules of the American Arbitration Association.
        </p>
        <p>
          C. Pre-Dispute Resolution Procedure. For the purposes of this Section,
          “COMPANY Party" or "COMPANY PARTIES” shall mean COMPANY and
          COMPANY&apos;s service providers and licensors, and their respective
          officers, directors, employees, contractors and agents when providing
          services for/on behalf of COMPANY. Before asserting a claim in any
          proceeding (including in an individual arbitration or in a small
          claims proceeding), FAP and the applicable COMPANY Party agree that
          each of FAP shall give the other party written notice of the claim to
          be asserted 30 days before initiating a proceeding and make a
          reasonable good faith effort to resolve the claim. If FAP are
          intending to assert a claim against a COMPANY Party, FAP must send the
          written notice of the claim to 100 Tradecenter Drive, Woburn, MA. If
          COMPANY is intending to assert a claim against FAP, COMPANY will send
          the written notice of the claim to the FAP address appearing in our
          records. NO SETTLEMENT DEMAND OR SETTLEMENT OFFER USED IN THIS
          PRE-DISPUTE RESOLUTION PROCESS MAY BE USED IN ANY PROCEEDING,
          INCLUDING AS EVIDENCE OR AS AN ADMISSION OF ANY LIABILITY OR DAMAGES
          (OR LACK THEREOF).
        </p>
        <p>
          D. Agreement to Arbitrate. In the event of a dispute that cannot be
          resolved informally through the pre-dispute resolution procedure, FAP
          and the COMPANY PARTIES agree to arbitrate all disputes and claims
          arising under or relating to any of these Terms, COMPANY&apos;s
          vehicles, COMPANY&apos;s services, or any other transaction involving
          FAP and COMPANY, whether in contract, warranty, misrepresentation,
          fraud, tort, intentional tort, statute, regulation, ordinance, or any
          other legal or equitable basis. The interpretation and scope of this
          provision, and the arbitrability of the dispute or claim, are for the
          arbitrator to decide.
        </p>
        <p>
          i. What is Arbitration? Arbitration is more informal than a lawsuit.
          Arbitration uses a neutral arbitrator instead of a judge or jury,
          allows for more limited discovery than in court, and is subject to
          very limited review by courts. Under this dispute resolution
          provision, arbitrators can award the same individual relief affecting
          individual PARTIES that a court can award, including damages and an
          award of attorneys' fees, if the applicable law allows. BY AGREEING TO
          RESOLVE DISPUTES THROUGH ARBITRATION, FAP AND COMPANY AGREE TO EACH
          UNCONDITIONALLY WAIVE THE RIGHT TO A TRIAL BY JURY OR COURT.
        </p>
        <p>
          ii. Class Action Waiver. FAP AND THE COMPANY PARTIES AGREE THAT ANY
          CLAIMS BROUGHT BY FAP OR THE COMPANY PARTIES WILL BE BROUGHT IN THE
          PARTIES' INDIVIDUAL CAPACITY AND WILL NOT BE BROUGHT AS A CLASS,
          REPRESENTATIVE,COLLECTIVE OR PRIVATE ATTORNEY GENERAL ACTION. The
          arbitrator may not consolidate more than one person's claims and may
          not otherwise preside over any form of a class, representative, or
          private attorney general proceeding. FAP and the COMPANY PARTIES agree
          to seek only such relief-whether in the form of damages, an
          injunction, or other non-monetary relief-as is necessary to resolve
          any individual injury that either FAP or COMPANY have suffered or may
          suffer. In particular, if either FAP or a COMPANY Party seek
          non-monetary relief, such relief must be individualized and may not
          affect individuals or entities other than FAP or the applicable
          COMPANY Party. This requirement that claims be brought in binding
          arbitration only in an individual capacity and not as a
          representative, private attorney general, or class Subscriber ("Class
          Action Waiver") is non-severable. If the Class Action Waiver is found
          to be unenforceable, then the entirety of this dispute resolution
          provision shall be null and void.
        </p>
      </div>

      <p className="font-semibold text-stone-200">XVII. MISCELLANEOUS</p>
      <div className="grid gap-2">
        <p>
          1. Amendments: Any amendments to this Agreement shall be made in
          writing and signed by both PARTIES.
        </p>
        <p>
          2. Entire Agreement: This Agreement constitutes the entire agreement
          between the PARTIES with respect to the subject matter hereof and
          supersedes all prior or contemporaneous agreements, representations,
          and understandings.
        </p>
        <p>
          3. Waiver: The waiver by either Party of any breach of this Agreement
          shall not operate as a waiver of any subsequent breach.
        </p>
        <p>
          4. Severability: If any provision of this Agreement is held to be
          invalid or unenforceable, the remaining provisions shall remain in
          full force and effect.
        </p>
        <p>
          5. Notices: Any notice required or permitted to be given under this
          Agreement shall be in writing and shall be delivered by hand,
          certified mail, or overnight courier to the addresses set forth above.
        </p>
      </div>

      <p className="font-semibold text-stone-200">XVIII. Entire Agreement</p>
      <p>
        This Agreement constitutes the entire understanding between the parties
        and supersedes all prior negotiations, discussions, or agreements,
        whether written or oral.
      </p>

      <p className="font-semibold text-stone-200">
        POSH FLEET ACQUISITION PARTNER ADDENDUM 1
      </p>
      <p className="font-semibold">INSURANCE CLAIMS FILING RESPONSIBILITIES</p>
      <p className="font-semibold">Claims Management by PoshCars.io</p>
      <div className="grid gap-2">
        <p>1. Purpose</p>
        <p>
          The purpose of this Addendum is to outline the terms under which
          COMPANY will assume responsibility for managing all vehicle-related
          claims on behalf of its Fleet Acquisition Partners.
        </p>
        <p>2. Scope of Claim Management</p>
        <p>
          PoshCars.io agrees to handle and process the following types of claims
          related to vehicles provided under the Partnership Agreement:
        </p>
        <p>● Insurance claims (accident, theft, vandalism, total loss, etc.)</p>
        <p>● Customer damage or misuse claims</p>
        <p>● Mechanical breakdowns and warranty-related issues</p>
        <p>● Third-party liability or subrogation claims</p>
        <p>3. Responsibilities of COMPANY</p>
        <p>PoshCars.io shall:</p>
        <p>
          ● File claims with applicable insurers and coordinate with repair
          facilities.
        </p>
        <p>● Manage communications with customers and third-party providers.</p>
        <p>● Deduct or recover applicable costs related to damage or loss.</p>
        <p>
          ● Provide periodic updates to the Partner regarding claim status and
          resolutions.
        </p>
        <p>● Maintain documentation and records of all claims processed.</p>
        <p>4. Responsibilities of the Fleet Partner</p>
        <p>Fleet Partner agrees to:</p>
        <p>
          ● Provide PoshCars.io with necessary documentation including but not
          limited to titles, insurance policies, service records, or incident
          details.
        </p>
        <p>
          ● Cooperate fully with PoshCars.io and any insurance providers during
          claim investigations.
        </p>
        <p>
          ● Allow PoshCars.io to act as the authorized agent for the purpose of
          claims and settlements.
        </p>
        <p>5. Claim Proceeds and Payments</p>
        <p>
          ● Any insurance claim payments will be routed through PoshCars.io and
          disbursed to the Fleet Partner in accordance with the outcome and the
          vehicle ownership structure.
        </p>
        <p>
          ● PoshCars.io may deduct repair or loss-related costs, including
          applicable deductibles or uninsured damages, before remitting balances
          to the Fleet Partner.
        </p>
        <p>6. Liability</p>
        <p>
          PoshCars.io shall exercise reasonable care in managing claims but
          shall not be liable for any delays, claim denials, or recoveries
          dependent on third parties, insurers, or customer actions.
        </p>
      </div>
      <div className="grid gap-2">
        <p className="font-semibold text-stone-200">
          POSH FLEET ACQUISITION PARTNER ADDENDUM 2: IRS MATERIAL PARTICIPATION
          COMPLIANCE RULES
        </p>
        <p>
          As part of the contractual obligations, Fleet Acquisition Partners
          (FAPs) must adhere to IRS regulations regarding material participation
          for tax purposes. To comply with the 500-hour material participation
          requirement, the following measures will be implemented:{" "}
        </p>
        <p>
          1. Booking & Customer Management Tools FAPs will have access to a
          dedicated dashboard enabling real-time booking approvals, vehicle
          availability tracking, direct customer messaging, and alerts for
          changes in rental status. System-generated reports will summarize time
          spent on customer interactions.
        </p>
        <p>
          2. Maintenance & Logistics Tracking A maintenance module will allow
          FAPs to approve and log scheduled services, receive automated service
          reminders, and assign tasks to third parties while tracking their own
          engagement. Hours spent managing logistics will be recorded as part of
          participation tracking.
        </p>
        <p>
          3. Automated Activity Logging & Time Reporting All platform-based
          activities performed by FAPs will be automatically logged, including
          customer support, booking management, and maintenance oversight.
          Monthly IRS-compliant participation reports will be generated for tax
          documentation purposes.
        </p>
        <p>
          4. Marketing & Referral Tools FAPs will receive access to personalized
          fleet landing pages, referral tracking programs, and social media
          integration tools. Time spent on promotion and community engagement
          will be tracked toward participation hours.
        </p>
        <p>
          5. Educational & Compliance Center An on-platform learning portal will
          offer IRS guidelines, tax optimization strategies, webinars, and
          training modules to help FAPs maintain compliance and maximize
          deductions. Completion hours will be recorded for participation
          validation.
        </p>
        <p className="text-stone-200">By signing below, I agree with the terms outlined in this agreement.</p>
      </div>
    </div>
  );
}
